import { render, staticRenderFns } from "./addNewVehicleDetails.vue?vue&type=template&id=ee78553c&scoped=true"
import script from "./addNewVehicleDetails.vue?vue&type=script&lang=js"
export * from "./addNewVehicleDetails.vue?vue&type=script&lang=js"
import style0 from "./addNewVehicleDetails.vue?vue&type=style&index=0&id=ee78553c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee78553c",
  null
  
)

export default component.exports